import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-stars',
  templateUrl: './review-stars.component.html',
  styleUrls: ['./review-stars.component.scss']
})
export class ReviewStarsComponent implements OnInit {
    @Input() stars: number;
    @Input() reviewCount: number;
    public width = 0;

    public get shouldShow(): boolean {
      return this.stars > 0 && this.reviewCount > 0;
    }

    public ngOnInit(): void {
      this.width = (this.stars / 5) * 100;
    }
}